import type { ReactNode } from "react";
import { cn } from "@/utils/cn";

interface ContentWithSidebarTemplateProps {
  content: ReactNode;
  sidebar: ReactNode;
}

export function ContentWithSidebarTemplate({ content, sidebar }: ContentWithSidebarTemplateProps) {
  return (
    <section className="min-h-screen bg-white px-4 py-6 sm:px-6 lg:px-8">
      <div className="mx-auto w-full">
        <div
          className={cn(
            "grid grid-cols-1 gap-5 xl:items-start xl:gap-6 xl:grid-cols-[minmax(0,1fr)_300px]",
          )}
        >
          <div>{content}</div>
          <div className="relative xl:w-[300px]">
            <aside
              className={cn(
                "space-y-4",
                "xl:fixed xl:top-26 xl:right-8 xl:z-10 xl:w-[300px]",
                "xl:max-h-[calc(100vh-1.5rem)] xl:overflow-y-auto",
              )}
            >
              {sidebar}
            </aside>
          </div>
        </div>
      </div>
    </section>
  );
}
